import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import { Children, forwardRef } from 'react';
import { Container } from '../../primitives/Flex/components/Container.js';
import { Divider } from '../../primitives/Flex/components/Divider.js';
export const Flex = /*#__PURE__*/_styled(forwardRef(({
  divider = false,
  dividerProps = {
    category: 'secondary',
    type: 'solid'
  },
  direction = 'column',
  spacing = 'global/large',
  children,
  ...restProps
}, ref) => {
  const items = Children.toArray(children);
  return _jsx(Container
  // Alias properties are set explicitly before spread to allow for default values
  , {
    // Alias properties are set explicitly before spread to allow for default values
    flexDirection: direction,
    gap: spacing,
    ...restProps,
    ref: ref,
    children: items.reduce((result, item, index) => {
      if (divider && index < items.length - 1) {
        return result.concat([item, _createElement(Divider, {
          ...dividerProps,
          key: `divider-${index}`,
          direction: direction
        })]);
      }
      return result.concat(item);
    }, [])
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e2qsad0"
} : {
  target: "e2qsad0",
  label: "Flex"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZsZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBcUJJIiwiZmlsZSI6IkZsZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHsgY3JlYXRlRWxlbWVudCBhcyBfY3JlYXRlRWxlbWVudCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQ2hpbGRyZW4sIGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0ZsZXgvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgRGl2aWRlciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvRmxleC9jb21wb25lbnRzL0RpdmlkZXIuanMnO1xuZXhwb3J0IGNvbnN0IEZsZXggPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBkaXZpZGVyID0gZmFsc2UsIGRpdmlkZXJQcm9wcyA9IHsgY2F0ZWdvcnk6ICdzZWNvbmRhcnknLCB0eXBlOiAnc29saWQnIH0sIGRpcmVjdGlvbiA9ICdjb2x1bW4nLCBzcGFjaW5nID0gJ2dsb2JhbC9sYXJnZScsIGNoaWxkcmVuLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiB7XG4gICAgY29uc3QgaXRlbXMgPSBDaGlsZHJlbi50b0FycmF5KGNoaWxkcmVuKTtcbiAgICByZXR1cm4gKF9qc3goQ29udGFpbmVyXG4gICAgLy8gQWxpYXMgcHJvcGVydGllcyBhcmUgc2V0IGV4cGxpY2l0bHkgYmVmb3JlIHNwcmVhZCB0byBhbGxvdyBmb3IgZGVmYXVsdCB2YWx1ZXNcbiAgICAsIHsgXG4gICAgICAgIC8vIEFsaWFzIHByb3BlcnRpZXMgYXJlIHNldCBleHBsaWNpdGx5IGJlZm9yZSBzcHJlYWQgdG8gYWxsb3cgZm9yIGRlZmF1bHQgdmFsdWVzXG4gICAgICAgIGZsZXhEaXJlY3Rpb246IGRpcmVjdGlvbiwgZ2FwOiBzcGFjaW5nLCAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjaGlsZHJlbjogaXRlbXMucmVkdWNlKChyZXN1bHQsIGl0ZW0sIGluZGV4KSA9PiB7XG4gICAgICAgICAgICBpZiAoZGl2aWRlciAmJiBpbmRleCA8IGl0ZW1zLmxlbmd0aCAtIDEpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gcmVzdWx0LmNvbmNhdChbXG4gICAgICAgICAgICAgICAgICAgIGl0ZW0sXG4gICAgICAgICAgICAgICAgICAgIF9jcmVhdGVFbGVtZW50KERpdmlkZXIsIHsgLi4uZGl2aWRlclByb3BzLCBrZXk6IGBkaXZpZGVyLSR7aW5kZXh9YCwgZGlyZWN0aW9uOiBkaXJlY3Rpb24gfSksXG4gICAgICAgICAgICAgICAgXSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICByZXR1cm4gcmVzdWx0LmNvbmNhdChpdGVtKTtcbiAgICAgICAgfSwgW10pIH0pKTtcbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUZsZXguanMubWFwIl19 */");